import React from "react";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import { FormGroup, FormLabel } from "@mui/material";
import MuiDatePicker from "../components/basicComponent/MuiDatePicker";

const Notifiy = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Alert And Notification</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiSearchSelect
                          placeholder={"Group"}
                          label="Group"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiSearchSelect
                          placeholder={"Corporate"}
                          label="Corporate"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton
                          className="clear-btn "
                          label="Clear"
                          type="submit"
                        />
                        <MuiButton
                          label={"Get"}
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                        />
                      </div>
                      {/* <MuiButton
                    label={editingUser ? "Update User" : "Create User"}
                    className="main-btn"
                    variant="contained"
                    size="large"
                    onClick={() => formik.handleSubmit()}
                  /> */}
                    </div>

                    <FormLabel
                      sx={{
                        color: " #38aecc",
                        fontWeight: "bold",
                      }}
                    >
                      TravelDesk
                      <span style={{ color: "red" }}>*</span>
                    </FormLabel>

                    <FormGroup
                      sx={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        borderRadius: "4px",
                        width: "100%",
                        height: "80px",
                      }}
                    >
                      <div className="row">
                        <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                          <MuiSearchSelect
                            placeholder={"Days"}
                            label="Days"
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-xl-2 col-lg-6 col-md-6 mb-3">
                          <MuiSearchSelect
                            placeholder="Product "
                            label={"Product"}
                            isRequired={true}
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                          <MuiSearchSelect
                            placeholder={"From"}
                            label="From"
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                          <MuiSearchSelect
                            placeholder={"To"}
                            label="To"
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                          <MuiInput
                            placeholder="Enter multiple Email with (,) seperator"
                            label={"Enter multiple Email with (,) seperator"}
                            isRequired={true}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <div className="row mt-4">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                        Booking Confirmation
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Days"}
                              label="Days"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Product "
                              label={"Product"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-1 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"From"}
                              label="From"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-1 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"To"}
                              label="To"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Type"}
                              label="Type"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                            <MuiInput
                              placeholder="Enter Email Id"
                              label={"Enter Email Id"}
                              isRequired={true}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="row mt-4">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                        Date Change / Reschedule
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Days"}
                              label="Days"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Product "
                              label={"Product"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"From"}
                              label="From"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-1 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"To"}
                              label="To"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Type"}
                              label="Type"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                            <MuiInput
                              placeholder="Enter Email Id"
                              label={"Enter Email Id"}
                              isRequired={true}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="row mt-4">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                        Travel Request
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Days"}
                              label="Days"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Product "
                              label={"Product"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"From"}
                              label="From"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-1 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"To"}
                              label="To"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Type"}
                              label="Type"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                            <MuiInput
                              placeholder="Enter Email Id"
                              label={"Enter Email Id"}
                              isRequired={true}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="row mt-4">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                        Travel Approval
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Days"}
                              label="Days"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Product "
                              label={"Product"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"From"}
                              label="From"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-1 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"To"}
                              label="To"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Type"}
                              label="Type"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                            <MuiInput
                              placeholder="Enter Email Id"
                              label={"Enter Email Id"}
                              isRequired={true}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="row mt-4">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                        Cancellation
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Days"}
                              label="Days"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Product "
                              label={"Product"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"From"}
                              label="From"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-1 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"To"}
                              label="To"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Type"}
                              label="Type"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                            <MuiInput
                              placeholder="Enter Email Id"
                              label={"Enter Email Id"}
                              isRequired={true}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-6">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                       Low Balance Alert
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Days"}
                              label="Days"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-5 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Product "
                              label={"Product"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                    
                   
                        </div>
                      </FormGroup>
                      </div>


                      <div className="col-md-6">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                       Help / Escalation Matrix
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                          <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Icon"}
                              label="Icon"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-3 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Label "
                              label={"Label"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Text "
                              label={"Text"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                   
                        </div>
                      </FormGroup>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-6">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                      Hotel Voucher Corporate
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                          <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Icon"}
                              label="Icon"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Label "
                              label={"Label"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Text "
                              label={"Text"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                   
                        </div>
                      </FormGroup>
                      </div>


                      <div className="col-md-6">
                      <FormLabel
                        sx={{
                          color: " #38aecc",
                          fontWeight: "bold",
                        }}
                      >
                       Hotel Voucher TravelDesk
                        <span style={{ color: "red" }}>*</span>
                      </FormLabel>

                      <FormGroup
                        sx={{
                          border: "1px solid #ccc",
                          padding: "8px",
                          borderRadius: "4px",
                          width: "100%",
                          height: "80px",
                        }}
                      >
                        <div className="row">
                        <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder={"Icon"}
                              label="Icon"
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Label "
                              label={"Label"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <MuiSearchSelect
                              placeholder="Text "
                              label={"Text"}
                              isRequired={true}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                   
                        </div>
                      </FormGroup>
                      </div>


                      <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                       
                        <MuiButton
                          label={"Insert"}
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                        />
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Notifiy;
